(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-coming-soon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zodiac-soon')) {
    customElements.define(
      'zodiac-soon',
      class ZodiacSoon extends HTMLElement {
        connectedCallback() {
          // The element can be defined before its contents are parsed; set up once they are.
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          else this.init();
        }

        init() {
          if (this.ready || !this.isConnected) return;
          this.ready = true;
          this.audio = this.querySelector('audio[data-soundtrack]');
          this.soundBtn = this.querySelector('[data-sound]');
          this.pauseBtn = this.querySelector('[data-pause]');
          // "1:05" or "65" → seconds
          const seconds = (value) => String(value || '0').split(':').reduce((total, part) => total * 60 + (parseFloat(part) || 0), 0);
          this.captions = Array.from(this.querySelectorAll('[data-caption]')).map((el) => {
            const start = seconds(el.dataset.start);
            return { el, start, end: start + (Number(el.dataset.duration) || 6) };
          });
          // Browsers block sound until the visitor asks for it, so the page starts silent: the timed
          // text follows a silent clock until "Play with sound" starts the track at the same moment.
          // Visitors who prefer reduced motion start paused and nothing plays by itself.
          this.sound = false;
          this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.elapsed = 0;
          this.last = performance.now();

          this.timer = setInterval(() => this.tick(), 200);
          if (this.paused) this.toggleAttribute('data-media-paused', true);
          this.update();
          if (this.bound) return;
          this.bound = true;

          // "Cut the video at": loop back to the start before the video's own ending.
          const end = parseFloat(this.dataset.videoEnd);
          if (end > 0) this.querySelectorAll('video').forEach((video) => this.cutVideo(video, end));

          this.addEventListener('click', (e) => {
            const toggle = e.target.closest('[data-show-panel]');
            if (toggle) {
              e.preventDefault();
              const name = toggle.dataset.showPanel;
              const open = this.querySelector(`[data-panel="${name}"].is-active`);
              this.show(open && name !== 'email' ? 'email' : name);
            } else if (e.target.closest('[data-sound]')) {
              this.toggleSound();
            } else if (e.target.closest('[data-pause]')) {
              this.setPaused(!this.paused);
            }
          });
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.querySelector('[data-panel="password"].is-active')) this.show('email');
          });
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.audio?.pause();
          this.ready = false;
        }

        cutVideo(video, end) {
          if ('requestVideoFrameCallback' in video) {
            const onFrame = (now, frame) => {
              if (frame.mediaTime >= end) video.currentTime = 0;
              video.requestVideoFrameCallback(onFrame);
            };
            video.requestVideoFrameCallback(onFrame);
          } else {
            video.addEventListener('timeupdate', () => {
              if (video.currentTime >= end) video.currentTime = 0;
            });
          }
        }

        get length() {
          const ends = this.captions.map((c) => c.end);
          return (this.audio && this.audio.duration) || Math.max(10, ...ends) + 10;
        }

        tick() {
          const now = performance.now();
          if (!this.paused && !this.sound) this.elapsed = (this.elapsed + (now - this.last) / 1000) % this.length;
          this.last = now;
          const time = this.sound && this.audio ? this.audio.currentTime : this.elapsed;
          this.captions.forEach((c) => c.el.classList.toggle('is-on', time >= c.start && time < c.end));
        }

        toggleSound() {
          const audio = this.audio;
          if (!audio) return;
          if (this.sound) {
            audio.muted = !audio.muted;
          } else {
            const start = this.elapsed;
            const seek = () => {
              if (start < audio.duration) audio.currentTime = start;
            };
            if (audio.readyState >= 1) seek();
            else audio.addEventListener('loadedmetadata', seek, { once: true });
            audio.muted = false;
            this.sound = true;
            if (this.paused) this.setPaused(false);
            audio.play().catch(() => {
              this.sound = false;
              this.update();
            });
          }
          this.update();
        }

        setPaused(paused) {
          this.paused = paused;
          this.toggleAttribute('data-media-paused', paused);
          this.querySelectorAll('video').forEach((video) => {
            if (paused) video.pause();
            else if (getComputedStyle(video).display !== 'none') {
              video.muted = true;
              video.play().catch(() => {});
            }
          });
          if (this.audio && this.sound) {
            if (paused) this.audio.pause();
            else this.audio.play().catch(() => {});
          }
          this.update();
        }

        update() {
          if (this.soundBtn) {
            const on = this.sound && !this.audio.muted;
            const labels = this.soundBtn.dataset;
            this.soundBtn.classList.toggle('is-on', on);
            this.soundBtn.querySelector('[data-sound-label]').textContent = !this.sound ? labels.labelStart : on ? labels.labelMute : labels.labelUnmute;
          }
          if (this.pauseBtn) {
            this.pauseBtn.classList.toggle('is-paused', this.paused);
            this.pauseBtn.setAttribute('aria-label', this.paused ? this.pauseBtn.dataset.labelPlay : this.pauseBtn.dataset.labelPause);
          }
        }

        show(name) {
          const panel = this.querySelector(`[data-panel="${name}"]`);
          if (!panel || panel.classList.contains('is-active')) return;
          this.querySelectorAll('[data-panel]').forEach((p) => {
            const on = p === panel;
            p.classList.toggle('is-active', on);
            p.inert = !on;
          });
          const toggle = this.querySelector('[data-show-panel="password"]');
          toggle?.setAttribute('aria-expanded', String(name === 'password'));
          const focus = name === 'password' ? panel.querySelector('input:not([type="hidden"])') : toggle;
          focus?.focus({ preventScroll: true });
          this.dispatchEvent(new CustomEvent('zodiac:panel', { detail: { panel } }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zodiac-header')) {
    customElements.define(
      'zodiac-header',
      class ZodiacHeader extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('.z-header__toggle');
          this.closeButton = this.querySelector('.z-header__close');
          this.drawer = this.querySelector('.z-header__drawer');
          this.bar = this.querySelector('.z-header__bar');
          this.transparent = this.classList.contains('z-header--transparent');
          this.onScroll = this.onScroll.bind(this);
          this.onKey = this.onKey.bind(this);

          // Horizon scrolls the page inside .page-wrapper on desktop (html/body don't scroll there),
          // so watch both and use whichever has moved.
          this.scroller = this.closest('.page-wrapper');
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
          if (this.scroller) {
            // Keep the fixed header off the page-wrapper's own scrollbar.
            this.scrollbarObserver = new ResizeObserver(() => {
              const width = this.scroller.offsetWidth - this.scroller.clientWidth;
              this.style.setProperty('--z-scrollbar', `${Math.max(0, width)}px`);
            });
            this.scrollbarObserver.observe(this.scroller);
          }
          this.onScroll();

          this.addEventListener('focusin', () => {
            if (this.querySelector(':focus-visible')) this.classList.remove('is-hidden');
          });
          this.toggle?.addEventListener('click', () => this.setOpen(true));
          this.closeButton?.addEventListener('click', () => this.setOpen(false));
          this.querySelectorAll('[data-open-panel]').forEach((btn) =>
            btn.addEventListener('click', () => this.showPanel(btn.dataset.openPanel))
          );
          this.drawer?.addEventListener('click', (event) => {
            if (event.target.closest('a')) this.setOpen(false);
          });
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          this.scroller?.removeEventListener('scroll', this.onScroll);
          this.scrollbarObserver?.disconnect();
          document.removeEventListener('keydown', this.onKey);
          document.documentElement.style.removeProperty('overflow');
        }

        onScroll() {
          const y = Math.max(0, window.scrollY, this.scroller?.scrollTop || 0);
          if (this.transparent) {
            // Like the reference: turn to glass once the hero (the first section) has scrolled away.
            const hero = document.querySelector('main .shopify-section .z-section, main section');
            const scrolled = hero ? hero.getBoundingClientRect().bottom <= 72 : y > 600;
            this.classList.toggle('is-scrolled', scrolled);
          }

          // Hide on the way down, show again as soon as the visitor scrolls up.
          const mode = this.dataset.autohide;
          const autohide = mode === 'all' || (mode === 'mobile' && window.matchMedia('(max-width: 989px)').matches);
          const last = this.lastY ?? y;
          this.lastY = y;
          if (!autohide || this.classList.contains('is-open') || this.querySelector(':focus-visible')) {
            this.classList.remove('is-hidden');
            return;
          }
          const barHeight = this.bar.offsetHeight;
          if (y <= barHeight) this.classList.remove('is-hidden');
          else if (y > last + 4) this.classList.add('is-hidden');
          else if (y < last - 4) this.classList.remove('is-hidden');
        }

        onKey(event) {
          if (event.key === 'Escape') this.setOpen(false);
        }

        setOpen(open) {
          this.classList.toggle('is-open', open);
          this.toggle.setAttribute('aria-expanded', String(open));
          this.drawer.setAttribute('aria-hidden', String(!open));
          this.drawer.inert = !open;
          document.documentElement.style.overflow = open ? 'hidden' : '';
          if (open) {
            document.addEventListener('keydown', this.onKey);
            this.showPanel('root');
            this.closeButton?.focus({ preventScroll: true });
          } else {
            document.removeEventListener('keydown', this.onKey);
            this.toggle.focus({ preventScroll: true });
          }
        }

        showPanel(name) {
          this.querySelectorAll('.z-header__panel').forEach((panel) =>
            panel.classList.toggle('is-active', panel.dataset.panel === String(name))
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-series"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zodiac-tabs')) {
    customElements.define(
      'zodiac-tabs',
      /** Tabs (works on its own; the motion script listens for "zodiac:tab" to animate the panel in). */
      class ZodiacTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.list = this.querySelector('[role="tablist"]');
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
              if (!dir) return;
              e.preventDefault();
              this.select((i + dir + this.tabs.length) % this.tabs.length);
              this.tabs[this.current].focus();
            });
          });
          this.addEventListener('shopify:block:select', (e) => {
            const i = this.panels.indexOf(e.target.closest('[role="tabpanel"]'));
            if (i > -1) this.select(i);
          });
          this.current = Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
          requestAnimationFrame(() => this.center(false));
        }

        select(i) {
          if (i === this.current) return;
          this.current = i;
          this.tabs.forEach((tab, j) => {
            const on = j === i;
            tab.setAttribute('aria-selected', String(on));
            tab.tabIndex = on ? 0 : -1;
          });
          this.panels.forEach((panel, j) => (panel.hidden = j !== i));
          this.center(true);
          this.dispatchEvent(new CustomEvent('zodiac:tab', { detail: { panel: this.panels[i] } }));
        }

        center(smooth) {
          const tab = this.tabs[this.current];
          if (!tab || this.list.scrollWidth <= this.list.clientWidth) return;
          const left = tab.offsetLeft - (this.list.clientWidth - tab.offsetWidth) / 2;
          this.list.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
